import styled from 'styled-components';
import { rem } from 'polished';
import { DatePicker, KeyboardDatePicker } from '@material-ui/pickers';

export const StyledWrapperTimes = styled.div`
  display: flex;
  width: ${props => props.small === true && '28%'};
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;

  /* Input */
  .MuiInputBase-root {
    &:before {
      border: none;
    }
  }
  .MuiInput-underline:hover:not(.Mui-disabled):before,
  .MuiInput-underline:after {
    border: none;
  }
  .MuiInputBase-input {
    line-height: 1.2;
    /* Estilos comunes Input y text Area */
    padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
    width: 100%;
    font-size: ${rem('14px')};
    border: ${rem('1px')} solid #d0d0d0;
  }
  .MuiInput-underline.Mui-error:after {
    border: none;
  }
  .MuiFormHelperText-root.Mui-error {
    font-size: ${rem('14px')};
    color: #e71d02;
  }
  /* Calendar */
  .MuiPickerDTToolbar-toolbar {
    background-color: #f95752;
  }
`;

export const StyledKeyBoardDatePicker = styled(KeyboardDatePicker)`
  width: 100%;

  /* Input */
  .MuiInputBase-root {
    &:before {
      border: none;
    }
  }
  .MuiInput-underline:hover:not(.Mui-disabled):before,
  .MuiInput-underline:after {
    border: none;
  }
  .MuiInputBase-input {
    line-height: 1.2;
    /* Estilos comunes Input y text Area */
    padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
    width: 100%;
    font-size: ${rem('14px')};
    border: ${rem('1px')} solid #d0d0d0;
  }
  .MuiInput-underline.Mui-error:after {
    border: none;
  }
  .MuiFormHelperText-root.Mui-error {
    font-size: ${rem('14px')};
    color: #e71d02;
  }
  /* Calendar */
  .MuiPickerDTToolbar-toolbar {
    background-color: #f95752;
  }
`;
